import { Injectable } from '@angular/core';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { Action } from '@ngrx/store/src/models';
import { ForgotPasswordService } from '../../services/forgot-password/forgot-password.service';
import {
  ForgotPasswordActionTypes,
  ForgotPasswordRequestLinkSuccessAction,
  ForgotPasswordRequestLinkErrorAction,
  ForgotPasswordRequestResetSuccessAction,
  ForgotPasswordRequestResetErrorAction
} from '../../actions/forgot-password/forgot-password.actions';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

@Injectable()
export class ForgotPasswordEffects {
  @Effect()
  public requestLink(): Observable<Action> {
    return this.actions.pipe(
      ofType(ForgotPasswordActionTypes.REQUEST_LINK),
      exhaustMap((action: any) => {
        return this.forgotPasswordService.requestLink(action.captcha, action.email).pipe(
          map(response => {
            if (!response.success) {
              return ForgotPasswordRequestLinkErrorAction({ error: new Error(response.message) });
            }

            return ForgotPasswordRequestLinkSuccessAction({ response: <ApiResponseSimple>response });
          }),
          catchError(error => of(ForgotPasswordRequestLinkErrorAction({ error })))
        );
      })
    );
  }

  @Effect()
  public requestReset(): Observable<Action> {
    return this.actions.pipe(
      ofType(ForgotPasswordActionTypes.REQUEST_RESET),
      exhaustMap((action: any) => {
        return this.forgotPasswordService.requestReset(action.captcha, action.token, action.password).pipe(
          map(response => {
            if (!response.success) {
              return ForgotPasswordRequestResetErrorAction({ error: new Error(response.message) });
            }

            return ForgotPasswordRequestResetSuccessAction({ response: <ApiResponseSimple>response });
          }),
          catchError(error => of(ForgotPasswordRequestResetErrorAction({ error })))
        );
      })
    );
  }

  constructor(private actions: Actions, private forgotPasswordService: ForgotPasswordService) {}
}
